import React from 'react'
import styles from './pupil.styles'
import injectSheet from 'react-jss'
import UserAvatar from 'pobble-components/dist/user-avatar'

const Pupil = ({ classes, className, avatarUrl, name, displayName }) => (
  <div className={classes.container}>
    <UserAvatar className={classes.avatar} name={name} />
    <div className={classes.desc}>
      <span className={classes.name}>{name}</span>
      <span className={classes.displayName}>{displayName}</span>
    </div>
  </div>
)

export default injectSheet(styles)(Pupil)
